import { MatriculaLogPorIdResolver } from "./matricula-log.resolver";

export const LogResolvers = [
    MatriculaLogPorIdResolver
]